import { render } from "./NewBlog.vue?vue&type=template&id=6f2a38bc&scoped=true"
import script from "./NewBlog.vue?vue&type=script&lang=js"
export * from "./NewBlog.vue?vue&type=script&lang=js"

import "./NewBlog.vue?vue&type=style&index=0&id=6f2a38bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2a38bc"]])

export default __exports__